// @ts-nocheck

import * as React from 'react';

import {classify} from 'src/utils/index';
import CloseIcon from 'src/images/close-icon.svg';

import css from './style.css';


type Props = {
  onClick: any;
  className?: string;
  children: React.ReactNode;
  pillColor?: string;
};

const FilledToken = ({className, onClick, children, pillColor}: Props) => (
  <div className={classify(css.filledToken, className)} onClick={onClick}>
    {pillColor && (
      <div className={css.pillBar} style={{backgroundColor: pillColor}} />
    )}
    <span className={css.filledTokenValue}>{children}</span>
    <CloseIcon className={css.deleteFilledToken} />
  </div>
);

export default FilledToken;
